import { render, staticRenderFns } from "./JobAlertEditPopUp.vue?vue&type=template&id=506fd0f8&scoped=true&"
import script from "./JobAlertEditPopUp.vue?vue&type=script&lang=ts&"
export * from "./JobAlertEditPopUp.vue?vue&type=script&lang=ts&"
import style0 from "./JobAlertEditPopUp.vue?vue&type=style&index=0&lang=css&"
import style1 from "./JobAlertEditPopUp.vue?vue&type=style&index=1&id=506fd0f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506fd0f8",
  null
  
)

export default component.exports